import styled from "styled-components";
import {Navbar as navBar, Nav as nav, NavLink as link} from "react-bootstrap";

export const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
`

export const NavBar = styled(navBar)`
  height: 60px;
  background-color: whitesmoke;
  justify-content: space-between;
`

export const Nav = styled(nav)`
  padding: 20px;
  gap: 30px;
  font-size: 14px;
  
  button {
    font-size: 14px;
    vertical-align: middle;
    img {
      margin-left: 10px;
      height: 28px;
      width: 28px;
    }
  }
`

export const NavLink = styled(link)`
  text-decoration: underline;
  color: ${({theme}) => theme.text};
  font-weight: 600;
  padding-left: 0;
  padding-right: 0;
`

export const Content = styled.div`
`
